import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestStatus } from '../../utils/Enums';
import { apiClient } from '../../utils/ApiClient';
import {Email} from "../../models/Email";

interface EmailsState {
    emails: Email[];
    getEmailsStatus: RequestStatus;
    currentPage: number;
    totalPages: number;
    total: number;
}
const initialState: EmailsState = {
    emails: [],
    getEmailsStatus: RequestStatus.Idle,
    currentPage: 1,
    totalPages: 1,
    total: 0
};

export const getEmails = createAsyncThunk(
    'emails/getEmails',
    async ({ user, timeFrom, timeTo, page, perPage }: { user: string; timeFrom: string; timeTo: string; page: number; perPage: number }, { rejectWithValue }) => {
        const url = `emails?user=${user}&timeFrom=${timeFrom}&timeTo=${timeTo}&page=${page}&perPage=${perPage}`;
        const response = await apiClient.get(url);
        return response.data;
    }
);

const emailsSlice = createSlice({
    name: 'emails',
    initialState,
    reducers: {
        setCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmails.pending, (state) => {
                state.getEmailsStatus = RequestStatus.Loading;
            })
            .addCase(getEmails.fulfilled, (state, action) => {
                state.getEmailsStatus = RequestStatus.Success;
                state.emails = action.payload.data;
                state.currentPage = action.payload.current_page;
                state.totalPages = action.payload.last_page;
                state.total = action.payload.total;
            })
            .addCase(getEmails.rejected, (state, action) => {
                state.getEmailsStatus = RequestStatus.Failed;
            });
    },
});

export const { setCurrentPage } = emailsSlice.actions;
export default emailsSlice.reducer;